 export const MODULES_LIST = 'MODULES_LIST'
export const MODULES_PAGINATION = 'MODULES_PAGINATION'
  export const MODULE_INSERT = "MODULE_INSERT";
export const MODULE_UPDATE = "MODULE_UPDATE";
export const MODULE_DELETE = "MODULE_DELETE"